import TailwindBox from "library/components/_tailwind/box";
import TailwindText from "library/components/_tailwind/text";
import { inject, observer } from "mobx-react";
import React from "react";
import BroadcastStore from "../_stores/broadcast/BroadcastStore";
import LanguageStore from "library/core/stores/language/LanguageStore";
import ProfileStore from "common/my-page/stores/profile/ProfileStore";
import TailwindButton from "library/components/_tailwind/button";
import BroadcastStreamStore from "common/broadcast/_stores/broadcast-stream/BroadcastStreamStore";
import { BroadcastStreamType } from "common/broadcast/_stores/broadcast-stream/enums";
import TailwindFlex from "library/components/_tailwind/flex";
interface Props {
  broadcastStore?: BroadcastStore;
  languageStore?: LanguageStore;
  profileStore?: ProfileStore;
  broadcastStreamStore?: BroadcastStreamStore;
}

const BroadcastObsPreview: React.FunctionComponent<Props> = ({
  languageStore,
  profileStore,
  broadcastStreamStore,
}) => {
  const { isModel, modelProfile } = profileStore!;
  const { intl } = languageStore!;
  const { vrStreamConnected, setStreamType } = broadcastStreamStore!;

  return (
    // <TailwindBox padding={["py-36"]}>
    <TailwindFlex
      width={"w-full"}
      height={"h-full"}
      alignItems={"items-center"}
      flexDirection={"flex-col"}
      justifyContent={"justify-between"}
      gap={"gap-4"}>
      <TailwindText textColor='text-main-color'>
        {intl.formatMessage({
          id: "broadcast.broadcastPreview.streamConnected",
          defaultMessage: "Your obs stream is connected",
        })}
      </TailwindText>

      {isModel && modelProfile?.can_vr && !vrStreamConnected ? (
        <TailwindBox
          margin={["mb-2"]}
          display={"flex"}
          gap={"gap-8"}
          flexDirection={"flex-row"}
          justifyContent={"justify-between"}>
          <TailwindButton
            data-testid={"stream-type-use-vr-settings-button"}
            fullWidth={false}
            backgroundColor={"bg-gray-500"}
            textColor={"text-white"}
            onClick={() => setStreamType(BroadcastStreamType.VR)}>
            {intl.formatMessage({
              id: "broadcast.broadcastPreview.vr-settings",
              defaultMessage: "VR Settings",
            })}
          </TailwindButton>
        </TailwindBox>
      ) : (
        isModel &&
        modelProfile?.can_vr &&
        vrStreamConnected && (
          <TailwindText textColor='text-main-color'>
            {intl.formatMessage({
              id: "broadcast.broadcastPreview.vrStreamConnected",
              defaultMessage: "Your VR stream is connected",
            })}
          </TailwindText>
        )
      )}
      {/* </TailwindBox> */}
    </TailwindFlex>
  );
};

export default inject(
  "broadcastStore",
  "languageStore",
  "profileStore",
  "broadcastStreamStore"
)(observer(BroadcastObsPreview));
